export const httpServiceHost = {
    production: 'https://api.tokenlon.im',
    staging: 'https://api.imstaging.works',
    development: 'https://api.imdev.works',
};
export const jsonRpcServiceHost = {
    production: 'https://tokenlon-market.tokenlon.im/rpc',
    staging: 'https://tokenlon-market.imstaging.works/rpc',
    development: 'https://tokenlon-market.imdev.works/rpc',
};
//# sourceMappingURL=serviceHost.js.map